/* ==========================================================================
   AMVital — Brand Facts Enhancements (Eurus)
   File: assets/amvital-brand-facts.js
   Purpose: Smooth-scrolling for in-page anchors + FAQ deep-linking
   Notes:
   • No dependencies. Accessible. Respects reduced-motion.
   • Supports FAQ markup using .faq-item blocks (not <details>)
   • Creates IDs: #faq-q-1, #faq-q-2... on each .faq-item
   • Adds a small permalink button next to each FAQ H3
   • Guards toner links to canonical URL
   ========================================================================== */

(function () {
  const root = document.getElementById('amv-brand-facts');
  if (!root) return;

  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------- Smooth Scroll ---------------------------- */
  function smoothScrollTo(el) {
    if (!el) return;
    const useSmooth = !prefersReduced && 'scrollBehavior' in document.documentElement.style;

    try {
      el.scrollIntoView({ behavior: useSmooth ? 'smooth' : 'auto', block: 'start' });
      if (typeof el.focus === 'function') el.focus({ preventScroll: true });
    } catch (_) {
      const rect = el.getBoundingClientRect();
      const y = rect.top + (window.pageYOffset || document.documentElement.scrollTop) - 12;
      try {
        window.scrollTo({ top: y, behavior: useSmooth ? 'smooth' : 'auto' });
      } catch {
        window.scrollTo(0, y);
      }
      if (typeof el.focus === 'function') el.focus({ preventScroll: true });
    }
  }

  /* ---------------------- In-page Anchor Delegation --------------------- */
  root.addEventListener('click', function (e) {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const href = a.getAttribute('href');
    if (!href || href === '#') return;

    const id = href.slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    smoothScrollTo(target);

    try {
      if (location.hash === '#' + id) {
        history.replaceState && history.replaceState(null, '', '#' + id);
      } else {
        history.pushState && history.pushState(null, '', '#' + id);
      }
    } catch (_) {}
  });

  /* ------------------------- FAQ Auto-ID & Links ------------------------ */
  const faq = root.querySelector('#faq');
  if (faq) {
    const items = Array.from(faq.querySelectorAll('.faq-item'));

    items.forEach((item, i) => {
      const qId = `faq-q-${i + 1}`;
      const h = item.querySelector('h3');

      if (!item.id) item.id = qId;
      if (h && !h.id) h.id = `faq-h-${i + 1}`;

      // Add permalink button next to the question
      if (h && !h.querySelector('.amv-faq-permalink')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'amv-faq-permalink';
        btn.setAttribute('aria-label', 'Copy link to this question');
        btn.title = 'Copy link';
        btn.textContent = '#';

        btn.addEventListener('click', (ev) => {
          ev.preventDefault();
          ev.stopPropagation();

          const url = `${location.origin}${location.pathname}#${item.id}`;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).catch(() => {});
          }

          const prev = btn.textContent;
          btn.textContent = '✓';
          setTimeout(() => (btn.textContent = prev), 900);

          try {
            if (location.hash === '#' + item.id) {
              history.replaceState && history.replaceState(null, '', '#' + item.id);
            } else {
              history.pushState && history.pushState(null, '', '#' + item.id);
            }
          } catch (_) {}
        });

        // Minimal inline style to avoid extra CSS payload
        btn.style.marginLeft = '0.5rem';
        btn.style.fontSize = '0.9em';
        btn.style.opacity = '0.7';
        btn.style.background = 'transparent';
        btn.style.border = 'none';
        btn.style.cursor = 'pointer';
        btn.style.lineHeight = '1';
        btn.style.padding = '0';

        h.appendChild(btn);
      }
    });
  }

  /* ----------------- Handle existing and future hashes ------------------ */
  function handleHash() {
    const id = (location.hash || '').slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    setTimeout(() => smoothScrollTo(target), 0);
  }
  window.addEventListener('hashchange', handleHash);
  handleHash();

  /* ------------------- Ensure focusable section targets ----------------- */
  Array.from(root.querySelectorAll('h2, h3, section[id], .faq-item[id]')).forEach((el) => {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
  });

  /* ----------------------- Canonical Toner Link Fix ---------------------- */
  const correctTonerHref = '/products/amvital-turmeric-toner';
  root.querySelectorAll('a[href*="turmeric-toner"]').forEach((a) => {
    const current = a.getAttribute('href') || '';
    if (!current.endsWith(correctTonerHref)) a.setAttribute('href', correctTonerHref);
  });
})();